package org.example.zone360.pages.dashboard.chart

//import androidx.compose.runtime.Composable
//import com.varabyte.kobweb.compose.dom.svg.Polyline
//import com.varabyte.kobweb.compose.dom.svg.Svg
//import org.jetbrains.compose.web.css.px


//import androidx.compose.runtime.Composable
//import com.varabyte.kobweb.compose.dom.svg.Circle
//import com.varabyte.kobweb.compose.dom.svg.Path
//import com.varabyte.kobweb.compose.dom.svg.Svg
//import org.jetbrains.compose.web.css.px


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.stevdza.san.kotlinbs.components.BSTooltip
import com.stevdza.san.kotlinbs.components.initializeTooltips
import com.stevdza.san.kotlinbs.models.TooltipDirection
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Rect
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.dom.svg.Text
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.attr
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.wordBreak
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.example.zone360.models.WidgetTrend
import org.jetbrains.compose.web.css.px

@Composable
fun MiniBars(
    trends: List<WidgetTrend>,
    color: Color
) {
    LaunchedEffect(Unit) {
        initializeTooltips()
    }

    val maxBars = 10

    val actualTrends = trends
        .sortedBy { it.score.toInt() ?: 0 }
        .takeLast(maxBars)

    val displayTrends = buildList<WidgetTrend?> {

        repeat(maxBars - actualTrends.size) {
            add(null)
        }

        addAll(actualTrends)
    }

    Row(
        modifier = Modifier
            .width(150.px)
            .height(55.px),
        horizontalArrangement = Arrangement.spacedBy(4.px),
        verticalAlignment = Alignment.Bottom
    ) {

        displayTrends.forEachIndexed { index, trend ->

            val isEmpty = trend == null

            val score = trend?.score?.toInt() ?: 0

            val barHeight =
                if (isEmpty) {
                    8
                } else {
                    maxOf(8, (score * 50 / 100))
                }

            var isHovered by remember { mutableStateOf(false) }

            if (isEmpty) {
                Box(
                    modifier = Modifier
                        .width(10.px)
                        .height(barHeight.px)
                        .borderRadius(2.px)
                        .backgroundColor(color)
                        .styleModifier {
                            property("opacity", "0.20")
                        }
                )
            } else {
                Box(
                    modifier = Modifier
                        .styleModifier {
                            property("position", "relative")
                        }
                ) {
                    CustomTooltip(
                        sessionId = trend.sessionId.substringBefore("_"),
                        score = trend.score.toInt(),
                        dateTime = formatDateTime(trend.sessionDateTime)
                    ) {
                        Column(
                            horizontalAlignment = Alignment.CenterHorizontally,
                            modifier = Modifier.cursor(Cursor.Pointer)
                        ) {
                            SpanText(
                                text = score.toString(),
                                modifier = Modifier
                                    .fontSize(8.px)
                                    .margin(bottom = 2.px)
                            )

                            Box(
                                modifier = Modifier
                                    .width(10.px)
                                    .height(barHeight.px)
                                    .borderRadius(2.px)
                                    .backgroundColor(color)
                                    .styleModifier {
                                        property("opacity", getOpacity(score).toString())
                                    }
                            )
                        }
                    }
                }
            }
        }
    }
}

fun formatDateTime(timestamp: String): String {
    return try {

        val date = kotlin.js.Date(timestamp.toDouble())

        val day = date.getDate().toInt()
        val month = date.toLocaleString(
            "en-US",
            js("{ month: 'short' }")
        )
        val year = date.getFullYear().toInt()

        val time = date.toLocaleTimeString()

        "$day $month $year | $time"

    } catch (e: Exception) {
        timestamp
    }
}

@Composable
fun CustomTooltip(
    sessionId: String,
    score: Int,
    dateTime: String,
    content: @Composable () -> Unit
) {
    var isHovered by remember { mutableStateOf(false) }

    Box(
        modifier = Modifier
            .styleModifier {
                property("position", "relative")
                property("display", "inline-block")
            }
    ) {
        Box(
            modifier = Modifier
                .onMouseEnter { isHovered = true }
                .onMouseLeave { isHovered = false }
        ) {
            content()
        }

        if (isHovered) {
            Box(
                modifier = Modifier
                    .width(150.px)
                    .minHeight(100.px)
                    .fontSize(12.px)
                    .margin(bottom = 2.px)
                    .color(Colors.White)
                    .wordBreak(WordBreak.BreakAll)
                    .styleModifier {
                        property("position", "absolute")
                        property("bottom", "50%")
                        property("left", "50%")
                        property("transform", "translateX(-50%)")
                        property("background-color", "#1f2937")
                        property("padding", "5px 10px")
                        property("border-radius", "6px")
                        property("z-index", "10000")
                        property("box-shadow", "0 4px 6px rgba(0,0,0,0.1)")
                        property("min-width", "150.px")
                        property("white-space", "normal")
                        property("pointer-events", "none")
                    }
            ) {
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(4.px)
                ) {
                    // Session Name
                    SpanText(
                        text = sessionId,
                        modifier = Modifier
                            .fontSize(13.px)
                            .fontWeight(600)
                            .wordBreak(WordBreak.BreakAll)
                            .color(Colors.White)
                    )

                    // Score
                    SpanText(
                        text = "Score: $score",
                        modifier = Modifier
                            .fontSize(12.px)
                            .color(Colors.White)
                    )

                    // Date and Time
                    SpanText(
                        text = dateTime,
                        modifier = Modifier
                            .fontSize(11.px)
                            .color(Color.rgb(209, 213, 219))
                    )
                }

            }
        }
    }
}

private fun getOpacity(score: Int): Double {
    return when {
        score >= 90 -> 1.0
        score >= 80 -> 0.9
        score >= 70 -> 0.8
        score >= 60 -> 0.7
        score >= 50 -> 0.6
        score >= 40 -> 0.5
        score >= 30 -> 0.4
        score >= 20 -> 0.3
        score >= 10 -> 0.2
        else -> 0.1
    }
}
//@Composable
//fun MiniBars(
//    trends: List<WidgetTrend>,
//    color: com.varabyte.kobweb.compose.ui.graphics.Color
//) {
//
//    val maxBars = 10
//
//    val actualTrends = trends.takeLast(maxBars)
//
//    // Empty bars left, real data right
//    val displayTrends = buildList<WidgetTrend?> {
//
//        repeat(maxBars - actualTrends.size) {
//            add(null)
//        }
//
//        addAll(actualTrends)
//    }
//
//    val width = 150.0
//    val height = 60.0
//
//    val padX = 4.0
//    val padTop = 8.0
//    val padBottom = 6.0
//
//    val chartH = height - padTop - padBottom
//
//    val gap = 4.0
//    val barW = (width - padX * 2 - gap * (maxBars - 1)) / maxBars
//
//    val minBarH = 4.0
//
//    Svg(
//        attrs = {
//            width(150.px)
//            height(60.px)
//        }
//    ) {
//
//        // Top grid
//        Path(attrs = {
//            attr("d", "M 0 15 L 150 15")
//            attr("stroke", "#E5E7EB")
//            attr("stroke-width", "1")
//            attr("stroke-dasharray", "5 5")
//        })
//
//        // Middle grid
//        Path(attrs = {
//            attr("d", "M 0 35 L 150 35")
//            attr("stroke", "#E5E7EB")
//            attr("stroke-width", "1")
//            attr("stroke-dasharray", "5 5")
//        })
//
//        // Bottom grid
//        Path(attrs = {
//            attr("d", "M 0 55 L 150 55")
//            attr("stroke", "#E5E7EB")
//            attr("stroke-width", "1")
//            attr("stroke-dasharray", "5 5")
//        })
//
//        displayTrends.forEachIndexed { i, trend ->
//
//            val isEmpty = trend == null
//
//            val score = trend?.score?.toFloat() ?: 0f
//
//            val barH =
//                if (isEmpty) {
//                    8.0
//                } else {
//                    ((score / 100f) * chartH)
//                        .coerceAtLeast(minBarH.toDouble())
//                }
//
//            val x = padX + i * (barW + gap)
//            val y = padTop + chartH - barH
//
//            val lastRealBarIndex =
//                displayTrends.indexOfLast { it != null }
//
//            val isLastRealBar =
//                !isEmpty && i == lastRealBarIndex
//
//            Rect(attrs = {
//                attr("x", x.toString())
//                attr("y", y.toString())
//                attr("width", barW.toString())
//                attr("height", barH.toString())
//                attr("rx", "2")
//
//                if (isEmpty) {
//
//                    attr("fill", "#D1D5DB")
//                    attr("fill-opacity", "0.20")
//
//                } else {
//
//                    attr("fill", color.toString())
//
//                    attr(
//                        "fill-opacity",
//                        if (isLastRealBar) "1"
//                        else "0.45"
//                    )
//
//                    attr(
//                        "title",
//                        """
//                        Score: ${trend.score}
//                        Session: ${trend.sessionId.substringBefore("_")}
//                        Date: ${trend.sessionDateTime}
//                        """.trimIndent()
//                    )
//                }
//            })
//
//            // Show score only on actual bars
//            if (!isEmpty) {
//
//                Text(
//                    trend!!.score.toString(),
//                    attrs = {
//                        attr(
//                            "x",
//                            (x + barW / 2).toString()
//                        )
//
//                        attr(
//                            "y",
//                            (y - 1).toString()
//                        )
//
//                        attr(
//                            "text-anchor",
//                            "middle"
//                        )
//
//                        attr(
//                            "font-size",
//                            "8"
//                        )
//
//                        attr(
//                            "fill",
//                            "#374151"
//                        )
//
//                        attr(
//                            "font-weight",
//                            "500"
//                        )
//
//                        attr(
//                            "pointer-events",
//                            "none"
//                        )
//                    }
//                )
//            }
//        }
//    }
//}
//@Composable
//fun MiniBars(
//    trends: List<WidgetTrend>,
//    color: com.varabyte.kobweb.compose.ui.graphics.Color
//) {
//    val width = 150.0
//    val height = 60.0
//    val padX = 4.0
//    val padTop = 8.0
//    val padBottom = 6.0
//    val chartH = height - padTop - padBottom
//
//    val minVal = data.min()
//    val maxVal = data.max()
//    val range = (maxVal - minVal).takeIf { it != 0f } ?: 1f
//
//    val gap = 4.0
//    val barW = (width - padX * 2 - gap * (data.size - 1)) / data.size
//    val minBarH = 4.0 // sabse chota value bhi thoda visible rahe
//
//    Svg(
//        attrs = {
//            width(150.px)
//            height(60.px)
//        }
//    ) {
//        // Top grid
//        Path(attrs = {
//            attr("d", "M 0 15 L 150 15")
//            attr("stroke", "#E5E7EB")
//            attr("stroke-width", "1")
//            attr("stroke-dasharray", "5 5")
//        })
//
//        // Middle grid
//        Path(attrs = {
//            attr("d", "M 0 35 L 150 35")
//            attr("stroke", "#E5E7EB")
//            attr("stroke-width", "1")
//            attr("stroke-dasharray", "5 5")
//        })
//
//        // Bottom grid
//        Path(attrs = {
//            attr("d", "M 0 55 L 150 55")
//            attr("stroke", "#E5E7EB")
//            attr("stroke-width", "1")
//            attr("stroke-dasharray", "5 5")
//        })
//
//        // Bars
//        data.forEachIndexed { i, v ->
//            val barH = minBarH + ((v - minVal) / range) * (chartH - minBarH)
//            val x = padX + i * (barW + gap)
//            val y = padTop + chartH - barH
//            val isLast = i == data.lastIndex
//
//            Rect(attrs = {
//                attr("x", x.toString())
//                attr("y", y.toString())
//                attr("width", barW.toString())
//                attr("height", barH.toString())
//                attr("rx", "2")
//                attr("fill", color.toString())
//                attr("fill-opacity", if (isLast) "1" else "0.45")
//            })
//        }
//    }
//}

//@Composable
//fun Sparkline(
//    color: Color
//) {
//
//    val bars = listOf(
//        16,
//        22,
//        18,
//        30,
//        36,
//        42,
//        34
//    )
//
//    val opacities = listOf(
//        0.25,
//        0.35,
//        0.45,
//        0.55,
//        0.70,
//        0.85,
//        1.0
//    )
//
//    Svg(
//        attrs = {
//            width(140.px)
//            height(52.px)
//        }
//    ) {
//
//        bars.forEachIndexed { index, value ->
//
//            val x = index * 18
//            val y = 48 - value
//
//            // Main Bar
//            Rect(
//                attrs = {
//                    attr("x", x.toString())
//                    attr("y", y.toString())
//                    attr("width", "12")
//                    attr("height", value.toString())
//
//                    attr("rx", "6")
//                    attr("ry", "6")
//
//                    attr("fill", color.toString())
//                    attr(
//                        "fill-opacity",
//                        opacities[index].toString()
//                    )
//                }
//            )
//
//            // Highlight current session
//            if (index == bars.lastIndex) {
//
//                Rect(
//                    attrs = {
//                        attr("x", x.toString())
//                        attr("y", y.toString())
//                        attr("width", "12")
//                        attr("height", value.toString())
//
//                        attr("rx", "6")
//                        attr("ry", "6")
//
//                        attr("fill", "none")
//                        attr("stroke", "#FFFFFF")
//                        attr("stroke-width", "2")
//                    }
//                )
//            }
//        }
//    }
//}

//@Composable
//fun Sparkline(
//    color: com.varabyte.kobweb.compose.ui.graphics.Color
//) {
//
//    Svg(
//        attrs = {
//            width(150.px)
//            height(70.px)
//        }
//    ) {
//
//        // Top grid
//        Path(attrs = {
//            attr("d", "M 0 15 L 150 15")
//            attr("stroke", "#E5E7EB")
//            attr("stroke-width", "1")
//            attr("stroke-dasharray", "5 5")
//        })
//
//        // Middle grid
//        Path(attrs = {
//            attr("d", "M 0 35 L 150 35")
//            attr("stroke", "#E5E7EB")
//            attr("stroke-width", "1")
//            attr("stroke-dasharray", "5 5")
//        })
//
//        // Bottom grid
//        Path(attrs = {
//            attr("d", "M 0 55 L 150 55")
//            attr("stroke", "#E5E7EB")
//            attr("stroke-width", "1")
//            attr("stroke-dasharray", "5 5")
//        })
//
//        // Area Fill
//        Path(attrs = {
//            attr(
//                "d",
//                """
//                M 0 48
//                C 12 46, 18 42, 28 35
//                C 40 25, 55 28, 68 38
//                C 80 48, 95 32, 110 18
//                C 122 10, 132 28, 140 38
//                C 145 42, 148 38, 150 38
//                L 150 70
//                L 0 70
//                Z
//                """.trimIndent()
//            )
//
//            attr("fill", "#2563EB22")
//        })
//
//        // Main line
//        Path(attrs = {
//            attr(
//                "d",
//                """
//                M 0 48
//                C 12 46, 18 42, 28 35
//                C 40 25, 55 28, 68 38
//                C 80 48, 95 32, 110 18
//                C 122 10, 132 28, 140 38
//                C 145 42, 148 38, 150 38
//                """.trimIndent()
//            )
//
//            attr("fill", "none")
//            attr("stroke", color.toString())
//            attr("stroke-width", "3")
//            attr("stroke-linecap", "round")
//            attr("stroke-linejoin", "round")
//        })
//
//        // End point glow
//        Circle(attrs = {
//            attr("cx", "148")
//            attr("cy", "38")
//            attr("r", "7")
//            attr("fill", "white")
//        })
//
//        // End point
//        Circle(attrs = {
//            attr("cx", "148")
//            attr("cy", "38")
//            attr("r", "5")
//            attr("fill", color.toString())
//        })
//    }
//}

//@Composable
//fun Sparkline(
//    color: com.varabyte.kobweb.compose.ui.graphics.Color
//) {
//
//    Svg(
//        attrs = {
//            width(120.px)
//            height(24.px)
//        }
//    ) {
//
//        Polyline(
//            attrs = {
//
//                attr(
//                    "points",
//                    "0,15 15,13 30,16 45,9 60,12 75,6 90,18 105,11 120,13"
//                )
//
//                attr("fill", "none")
//                attr("stroke", color.toString())
//                attr("stroke-width", "2")
//                attr("stroke-linecap", "round")
//                attr("stroke-linejoin", "round")
//            }
//        )
//    }
//}